"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCircularReferenceReplacer = exports.httpReturnSafeError = exports.isBase64 = exports.atobHex = exports.btoaHex = exports.atob = exports.btoa = exports.ErrDataArrayReducer = exports.ErrDataReducer = exports.ErrorArrayReducer = exports.ArrayObjectsOperationType = exports.SortOrder = exports.getErrData = exports.asthrap = exports.thrap = exports.throwify = exports.thuck = exports.tpluck = exports.pluck = exports.passErrData = exports.MaxMin = void 0;
exports.replaceErrors = replaceErrors;
exports.isClass = isClass;
var MaxMin;
(function (MaxMin) {
    MaxMin[MaxMin["MAX"] = 0] = "MAX";
    MaxMin[MaxMin["MIN"] = 1] = "MIN";
})(MaxMin || (exports.MaxMin = MaxMin = {}));
/** passes a returned ErrData into the calling functions ErrData response */
const passErrData = (subFnRes, thisRes) => {
    thisRes.data = subFnRes.data;
    thisRes.err = subFnRes.err;
    return thisRes;
};
exports.passErrData = passErrData;
/** pluck gets k of T from an errData or return undefined, it is designed to assist in seeing which keys are available */
const pluck = (errData, k) => errData.data?.[k];
exports.pluck = pluck;
/** typed response pluck */
const tpluck = (errData, k) => (0, exports.pluck)(errData, k);
exports.tpluck = tpluck;
/** a version of pluck for @aws-sdk style which throws if err is non null
 * ( pluch gets k of T from an errData or return undefined, it is designed to assist in seeing which keys are available)
 *  */
const thuck = (errData, k) => {
    if (errData.err) {
        throw errData.err;
    }
    return errData.data?.[k];
};
exports.thuck = thuck;
/** changes an ErrData result to a @aws-sdk throwing function */
const throwify = (errData) => {
    if (errData.err) {
        throw errData.err;
    }
    return errData.data ?? {};
};
exports.throwify = throwify;
/** captures result or throws from an @aws-sdk throwing function */
const thrap = (result, errData) => {
    if (result instanceof Error) {
        errData.err = result;
    }
    else {
        errData.data = result;
    }
    return errData;
};
exports.thrap = thrap;
/** settles, dethrows and errdataifies an @aws-sdk async  */
const asthrap = async (promise, onError) => {
    const errData = (0, exports.getErrData)();
    try {
        errData.data = await promise;
    }
    catch (e) {
        errData.err = e;
        onError?.(e);
    }
    return errData;
};
exports.asthrap = asthrap;
const getErrData = () => ({ err: null, data: null });
exports.getErrData = getErrData;
/**
 * Not exported but may be useful as does largely pull out nested properties
 *
 * Now commented out as throwing Type instantiation is excessively deep and possibly infinite. in tsc v 4.8.2
 */
//https://stackoverflow.com/questions/68518274/how-to-deep-flatten-an-interface-in-typescript
/*
type Primitive = string | number | boolean
type FlattenPairs<T> = {[K in keyof T]: T[K] extends Primitive ? [K, T[K]] : FlattenPairs<T[K]>}[keyof T] & [PropertyKey, Primitive]
type Flatten<T> = {[P in FlattenPairs<T> as P[0]]: P[1]}
*/
/** */
var SortOrder;
(function (SortOrder) {
    SortOrder[SortOrder["ASCENDING"] = 1] = "ASCENDING";
    SortOrder[SortOrder["DESCENDING"] = -1] = "DESCENDING";
    SortOrder[SortOrder["NONE"] = 0] = "NONE";
})(SortOrder || (exports.SortOrder = SortOrder = {}));
var ArrayObjectsOperationType;
(function (ArrayObjectsOperationType) {
    ArrayObjectsOperationType["SEQUENTIAL"] = "SEQUENTIAL";
    ArrayObjectsOperationType["PARALLEL"] = "PARALLEL";
})(ArrayObjectsOperationType || (exports.ArrayObjectsOperationType = ArrayObjectsOperationType = {}));
/** concatenates array of errors into one error */
const ErrorArrayReducer = (errs) => errs.reduce((a, c) => {
    if (c) {
        if (!a) {
            a = c;
        }
        else {
            a = new Error(`${a.message} \n ${c.message}`);
        }
    }
    return a;
}, null);
exports.ErrorArrayReducer = ErrorArrayReducer;
const ErrDataReducer = (results) => results.reduce((acc, curr) => {
    const mutant = {
        err: curr.err ? (acc.err ? new Error(acc.err.message + '\n' + curr.err?.message) : new Error(curr.err?.message)) : acc.err,
        data: curr.data ? (acc.data ? [...acc.data, curr.data] : [curr.data]) : acc.data,
    };
    return mutant;
}, { err: null, data: null });
exports.ErrDataReducer = ErrDataReducer;
/* warning  Not Tested!!! currently gives bad return type ( or not )
 * merges the arrays of data where they are, err, arrays
 */
const ErrDataArrayReducer = (results) => results.reduce((acc, curr) => {
    const mutant = {
        err: curr.err ? (acc.err ? new Error(acc.err.message + '\n' + curr.err?.message) : new Error(curr.err?.message)) : acc.err,
        data: null,
    };
    if (curr.data instanceof Array && (mutant.data === null || mutant.data instanceof Array)) {
        mutant.data = curr.data ? (acc.data ? [...acc.data, ...curr.data] : [...curr.data]) : acc.data;
    }
    return mutant;
}, { err: null, data: null });
exports.ErrDataArrayReducer = ErrDataArrayReducer;
const btoa = (a) => (a ? Buffer.from(a, 'utf-8').toString('base64') : undefined);
exports.btoa = btoa;
const atob = (b) => (b ? Buffer.from(b, 'base64').toString('utf-8') : undefined);
exports.atob = atob;
/** caution when testing, a must have even number of characters as represents a hex value */
/** hex to b64 */
const btoaHex = (a) => (a ? Buffer.from(a, 'hex').toString('base64') : undefined);
exports.btoaHex = btoaHex;
/** b64 to hex */
const atobHex = (b) => (b ? Buffer.from(b, 'base64').toString('hex') : undefined);
exports.atobHex = atobHex;
const isBase64 = (s) => {
    if (!s || s.length % 4 !== 0)
        return false;
    // Exclude plain hex strings like "deadbeef" or "0A1B2C"
    if (/^(?:0x)?[0-9a-fA-F]+$/.test(s))
        return false;
    // Base64 character/padding check
    if (!/^[A-Za-z0-9+/]*={0,2}$/.test(s))
        return false;
    // Canonical round-trip check
    try {
        const normalized = s.replace(/=+$/, '');
        const roundTrip = Buffer.from(s, 'base64').toString('base64').replace(/=+$/, '');
        return normalized === roundTrip;
    }
    catch {
        return false;
    }
};
exports.isBase64 = isBase64;
/** stringifys errors so that they can be returned via http */
const httpReturnSafeError = (err) => {
    var error = null;
    if (err) {
        error = {};
        Object.getOwnPropertyNames(err).forEach((key) => {
            error[key] = err[key];
        });
    }
    return error;
};
exports.httpReturnSafeError = httpReturnSafeError;
function replaceErrors(_key, value) {
    if (value instanceof Error) {
        return (0, exports.httpReturnSafeError)(value);
    }
    return value;
}
const createCircularReferenceReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
        // Handle errors first using the existing standard function
        const errorHandled = replaceErrors(key, value);
        if (errorHandled !== value) {
            return errorHandled;
        }
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return '[Circular] keys: ' + Object.keys(value).join(', ');
            }
            seen.add(value);
        }
        return value;
    };
};
exports.createCircularReferenceReplacer = createCircularReferenceReplacer;
/** checks if is a class, used in datamodel export checks */
function isClass(value) {
    return typeof value === 'function' && !!value.prototype && !!value.prototype.constructor;
}
